import { getPaymentReminders } from "@api";

import { PaymentReminder } from "@SiteManagement/PaymentReminders/types/paymentreminders";

const loader = async (): Promise<{
    paymentReminders: Array<PaymentReminder>;
}> => {
    const { paymentReminders } = await getPaymentReminders();
    return { paymentReminders };
};

export default loader;
